module.exports = __webpack_public_path__ + "img/animals.c91876df.svg";